(function (){
    'use strict';

    angular
        .module('services')
        .service('ExhibitorsService', ExhibitorsService);

    ExhibitorsService.$inject = ['$http', 'API_BASE'];

    function ExhibitorsService ($http, API_BASE) {
        var service = this;

        service.getByFilterExhibitors = getByFilterExhibitors;
        service.getPremiumBooths      = getPremiumBooths;

        function getByFilterExhibitors (query) {
            return $http.get(API_BASE + '/physicalfairs/reports/exhibitors',{params:query});
        }

        function getPremiumBooths (query) {
            return $http.get(API_BASE + '/physicalfairs/reports/exhibitors/premium-booths',{params:query});
        }

    }
})();